import { ImportRequest as BaseImportRequest } from "importController";


export default class ImportRequest extends BaseImportRequest {
	getKey() {
		return String(this.getID());
	}
}
